export default {

    // ---------Select Location-------
    maxOnlyAllowed: "最多只允许 {{no}} 选择",
    selectionRequired: '必须选择一个',
    pleaseSelectAnyLocation: '请选择任何一个仓库',
    itemsAtLeastHave1Row: '至少需要 (1) 行',
    thereAreDocumentsAlreadyExists: '已有 {{exists}} 个文件存在',
    atLeastOneAreaIsRequired: '至少选择一个区域',

    pleaseSelectAtLeastAnyProperty: '请选择至少一个属性',
    changesSaved: '更改已保存',
    maxAllowed: '最大允许',
    pleaseSelectAtLeast1DataFilter: '请选择至少一个数据筛选条件',
    invalidUserId: '用户ID无效',

}